import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import colors from '@/styles/export.module.scss'
import { getDeviceColorSchemePreference } from '@/utils/helpers'
import { setupRegistry } from '.'

// Process the colors from export.module.scss
const themes = {
  light: {
    dark: false,
    colors: {}
  },
  dark: {
    dark: true,
    colors: {}
  }
}

// Parse the colors from the module
for (const [colorKey, hex] of Object.entries(colors)) {
  // console.log('THEME', colorKey, hex)
  // Skip if not a color definition (like text)
  if (!colorKey.includes('-') || !hex) continue

  const [theme, fullColorName] = colorKey.split('-')

  // Skip if not a valid theme
  if (!themes[theme]) continue

  // Extract color name and tone (if any)
  const match = fullColorName.match(/([a-z]+)(\d+)?/)
  if (!match) continue

  const [, colorName, tone] = match

  if (tone) {
    // For tones, we use the color name with tone suffix
    themes[theme].colors[`${colorName}${tone}`] = hex

    // Make the 400 tone the base color if no other is specified
    if (tone === '400' && !themes[theme].colors[colorName]) {
      themes[theme].colors[colorName] = hex
    }
  } else {
    // Add colors without tones directly
    themes[theme].colors[colorName] = hex
  }
}

// Initial theme to avoid blinking
const lastTheme = localStorage.getItem('lastTheme') ?? 'auto'
let isDark = lastTheme === 'dark'
if (lastTheme === 'auto') {
  isDark = getDeviceColorSchemePreference() === 'dark'
}

// Create a Vuetify 3 instance with the theme configuration
const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    // a snackbar is never a dialog: by default its back guard aborts every back navigation while it shows
    VSnackbar: { closeOnBack: false },
  },
  theme: {
    defaultTheme: isDark ? 'dark' : 'light',
    themes,
  },
})

// Add a setup function that checks registry before applying
export const setupVuetify = app => {
  if (setupRegistry.plugins.has('vuetify')) {
    return
  }

  app.use(vuetify)
  setupRegistry.plugins.add('vuetify')
}

export default vuetify
